import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const COMMON_PASSWORDS = [
  "password", "password1", "password123", "123456", "12345678", "qwerty",
  "abc123", "monkey", "master", "dragon", "111111", "baseball", "iloveyou",
  "trustno1", "sunshine", "princess", "welcome", "shadow", "superman",
  "michael", "football", "passw0rd", "hello", "charlie", "donald",
  "letmein", "admin", "welcome1", "solo", "666666", "7777777", "888888"
];

export function validatePassword(password) {
  const errors = [];
  
  if (!password || password.length < 10) {
    errors.push("Must be at least 10 characters");
  }
  
  if (!/[a-z]/.test(password)) {
    errors.push("Must contain lowercase letter");
  }
  
  if (!/[A-Z]/.test(password)) {
    errors.push("Must contain uppercase letter");
  }
  
  if (!/[0-9]/.test(password)) {
    errors.push("Must contain a number");
  }
  
  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    errors.push("Must contain a symbol (!@#$%^&*...)");
  }
  
  const lower = password.toLowerCase();
  if (COMMON_PASSWORDS.some(cp => lower.includes(cp))) {
    errors.push("Contains common password - choose something more unique");
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}